export default {
    data() {
        return {
            canSearchCnpj: true,
        }
    },
    methods: {
        async searchCnpj(cnpj) {
            this.loading = true;

            await axios.get('/webservice-information/search-cnpj', {
                params: {
                    cnpj: cnpj
                }
            })
                .then((response) => {
                    let result = response.data;

                    this.form.email = result.email;
                    this.form.social_name = result.name;
                    this.form.phone = result.phone;

                    this.canSearchCep = false;

                    this.form.zip_code = result.address.zip_code;
                    this.form.city = result.address.city;
                    this.form.neighborhood = result.address.district;
                    this.form.number = result.address.number;
                    this.form.state = result.address.state;
                    this.form.street = result.address.street;
                })
                .catch(() => {
                    this.form.email = null;
                    this.form.social_name = null;
                    this.form.phone = null;

                    this.form.zip_code = null;
                    this.form.city = null;
                    this.form.neighborhood = null;
                    this.form.number = null;
                    this.form.state = null;
                    this.form.street = null;
                })
                .finally(() => {
                    this.canSearchCep = true;
                    this.loading = false
                })
        },

        async changeCnpjInput(event) {
            let cnpj = event.target.value
                .replace('.', '')
                .replace('.', '')
                .replace('/', '')
                .replace('-', '');

            if (cnpj !== this.form.document) {
                this.form.document = cnpj;

                if (cnpj.length === 14 && this.form.document_type === 'CNPJ' && this.canSearchCnpj) {
                    await this.searchCnpj(cnpj);
                }
            }
        },
    }
}
